import { useNavigate, Link } from "react-router-dom";
import { useStore } from "../../store";
import { useEffect, useState } from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import "./index.css";
import Switch from "react-switch";
import Button from "../../components/Button";

type lightSettingProps = {};

type TypeState = 'chamber' | 'screen'

function MenuLightSetting(props: lightSettingProps) {
  const { dataStore } = useStore();
  const resData = toJS(dataStore).resData;
  const navigate = useNavigate();

  const settingData = resData.loadSettingAck;



  const [type, setType] = useState<TypeState>('screen');

  const [value, setValue] = useState(settingData?.screenLight);

  const onChangeType = function (str: TypeState) {
    setType(str)
  };


  const onChangeLight = (event: any) => {
    setValue(Number(event.target.value))
  };


  const toggleLight = () => {
    dataStore.sendData({
      action: "toggleLight",
      data: {
        open: !resData.loadNavStatusAck?.light,
      },
    });
  };


  useEffect(() => {
    dataStore.sendData({
      action: "updateSetting",
      data: {
        key: type === 'screen' ? 'screenLight' : 'chamberLight',
        value: Number(value)
      }
    });


    if (type !== 'screen') {
      const timer = setTimeout(() => {
        dataStore.sendData({
          action: "toggleLight",
          data: {
            open: !!resData.loadNavStatusAck?.light,
          },
        });
      }, 100);

      return () => {
        clearTimeout(timer);
      };
    }

  }, [value])

  useEffect(() => {
    setValue(type === 'screen' ? settingData?.screenLight : settingData?.chamberLight)
  }, [type])

  return (
    <div className="flex bg-quickStartPrimaryBgColor">
      <div className="absolute w-[1280px] h-[730px] flex">
        <div className="w-2/5 relative">
          <Button
            options={{
              text: "Screen Light",
              class: "bg-buttonRunBgColor text-lg px-8 absolute inset-0 m-auto",
              cb: () => onChangeType('screen'),
            }}
            style={{
              padding: "0px 40px",
              boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
              backgroundColor: "#406F70",
              fontSize: "24px",
              marginTop: "240px",
              width: "265px",
              borderColor: type === "screen" ? "white" : "transparent",
              borderStyle: "solid",
              borderWidth: "2px",

            }}
          />
          <br></br>
          <br></br>
          <Button
            options={{
              text: "Chamber Light",
              class: "bg-buttonRunBgColor text-lg px-8 absolute inset-0 m-auto",
              cb: () => onChangeType('chamber'),
            }}
            style={{
              padding: "0px 40px",
              boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
              backgroundColor: "#406F70",
              fontSize: "24px",
              width: "265px",
              borderColor: type === "chamber" ? "white" : "transparent",
              borderStyle: "solid",
              borderWidth: "2px",
            }}
          />
        </div>
        <div className="w-3/5 relative">
          <div className="border-2 rounded-2xl absolute inset-0 m-auto w-11/12 h-2/6 mr-[100px] mt-[200px] bg-[#e8811f] opacity-70 shadow-[4px_4px_4px_1px_rgba(0,0,0,0.3)]"></div>

          <div className="border-2 rounded-2xl h-24 w-3/4 absolute inset-0 bg-[#f47f1f] mt-[275px] ml-[30px]">
            <div className="w-8/12 mt-9 inline-block ml-10">
              <input
                className="light-setting-range"
                type="range"
                value={value}
                min={10}
                max={100}
                step={10}
                onChange={onChangeLight}
              />
            </div>

            <div className="inline-block text-white font-bold text-5xl absolute mt-5">
              {(value || 0) + "%"}

            </div>


          </div>


          <div className="flex h-10 w-3/4 absolute inset-0  mt-[385px] ml-[30px]"
            style={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {type === 'chamber' && (
              <Switch
                onChange={value => toggleLight()}
                checked={!!resData.loadNavStatusAck?.light}
                uncheckedIcon={false}
                checkedIcon={false}
                onColor={"#5ede4e"}
              />
            )}

          </div>

        </div>


      </div>

      <Button
        options={{
          text: "RETURN",
          class: "bg-buttonRunBgColor text-lg px-8 absolute inset-0 m-auto",
          cb: () => navigate(-1),
        }}
        style={{
          padding: "0px 40px",
          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
          backgroundColor: "#406F70",
          marginLeft: "55px",
          fontSize: "24px",
          top: "0",
          marginTop: '630px',
          width: '200px'
        }}
      />


    </div>
  );
}
export default observer(MenuLightSetting);
